import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
export function PainSection() {
  return <section className="py-8 px-4 bg-swiss-pain-bg border-y border-red-100" data-id="element-112">
      <div className="max-w-xl mx-auto" data-id="element-113">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-114">
          <h2 className="text-2xl sm:text-3xl font-black text-swiss-charcoal mb-3" data-id="element-115">
            Sonntag. 18:00 Uhr.
          </h2>

          <p className="text-base sm:text-lg text-gray-700 mb-5 leading-relaxed" data-id="element-116">
            Die Woche beginnt morgen. Sie öffnen Ihren Laptop. Die Lehrbücher
            sind veraltet. Die Gesetze haben sich geändert. Die Schüler wollen
            echte Schweizer Fälle, keine abstrakten Beispiele aus deutschen
            Lehrbüchern. Und Ihre freie Zeit verschwindet wieder.
          </p>

          <div className="space-y-3 mb-5" data-id="element-117">
            {['Stunden verschwendet mit der Suche nach aktuellen OR/ZGB-Beispielen.', 'Schüler, die sich langweilen weil die Fälle nicht zur Schweiz passen.', 'Wochenenden, die der Unterrichtsvorbereitung geopfert werden.', 'Kein System. Nur lose Blätter und halbfertige Planungen.'].map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-118">
                <XCircleIcon className="w-6 h-6 text-swiss-red shrink-0 mt-0.5" data-id="element-119" />
                <p className="text-swiss-red font-bold text-base sm:text-lg leading-snug" data-id="element-120">
                  {item}
                </p>
              </div>)}
          </div>

          <p className="text-xl sm:text-2xl font-black text-swiss-charcoal text-center" data-id="element-121">
            Es gibt einen besseren Weg.
          </p>
        </motion.div>
      </div>
    </section>;
}